
export const initScrollAnimation = () => {
  const revealElements = document.querySelectorAll('.reveal, .reveal-right');
  
  const revealOnScroll = () => {
    const windowHeight = window.innerHeight;
    const revealPoint = 150;
    
    revealElements.forEach(element => {
      const revealTop = element.getBoundingClientRect().top;
      
      if (revealTop < windowHeight - revealPoint) {
        element.classList.add('active');
      }
    });
  };
  
  window.addEventListener('scroll', revealOnScroll);
  window.addEventListener('load', revealOnScroll);
  
  // Initial check in case elements are already in view when page loads
  setTimeout(revealOnScroll, 100);
  
  return () => {
    window.removeEventListener('scroll', revealOnScroll);
    window.removeEventListener('load', revealOnScroll);
  };
};
